import axios from 'axios'

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
}

const getters = {
  SELECT_PROV: state => state.provId,
  INPUTS_PROV: state => state.inputs,
  AMOUNT_PROV: state => state.amount,
}
const mutations = {
  SET_SELECT_PROV: (state, payload) => {
    state.provId = payload.id
  },
  SET_INPUTS_PROV: (state, payload) => {
    state.inputs = payload.inputs
  },
  SET_AMOUNT_PROV: (state, payload) => {
    state.amount = payload.amount
  },
}
const actions = {
  SAVE_SELECT_PROV: async (context, payload) => {
    context.commit('SET_SELECT_PROV', payload)
  },
  SAVE_INPUTS_PROV: async (context, payload) => {
    context.commit('SET_INPUTS_PROV', payload)
  },
  SAVE_AMOUNT_PROV: async (context, payload) => {
    context.commit('SET_AMOUNT_PROV', payload)
  },
  GET_PAY_CREATE: async (context, payload) => {
    const { data } = await axios.post('/wallet/pay/create', payload, config)
    return data
  },
  GET_CLEAR_PAY_INFO: async (context) => {
    context.commit('SET_SELECT_PROV', {id: null})
    context.commit('SET_INPUTS_PROV', {inputs: null})
    context.commit('SET_AMOUNT_PROV', {amount: null})
  },
}

export default {
  state: () => ({
    provId: null,
    inputs: null,
    amount: null
  }),
  mutations,
  actions,
  getters
}
